import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModules } from '../utils/modules';

/**
 * Route element that gates its children behind a domain module key, resolved
 * from __MODULE_SETTINGS__ — a build-time constant injected by
 * webpack.DefinePlugin from proto-cloud/module-catalog (see webpack.config.js
 * and app/utils/modules.js). A claimcolony build and a cche build are two
 * different compiled bundles, so this never involves a fetch or a loading
 * state.
 *
 * Mirrors SubdomainGate's shape/behavior for module-based gating instead of
 * host-based gating: redirect to "/" when the module is off.
 */
const ModuleGate = ({ module, children }) => {
    const { isModuleEnabled } = useModules();
    if (!isModuleEnabled(module)) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default ModuleGate;
